console.log("REACT_APP_API_URL =", process.env.REACT_APP_API_URL);
export const API_URL =
  process.env.REACT_APP_API_URL || "https://teachlearnfullstack.onrender.com";
  // "http://localhost:4000" || "https://teachlearnfullstack.onrender.com";